import type { AppState } from '@/types/store/app'
import { defineStore } from 'pinia'
import { i18n } from '@/utils/i18n/index';
import { getConfig } from '@/utils/config';
import { kexApp, KEX } from '@/utils/constants';
// import { config, configKex } from '@/utils/config';
// 存储全局状态
export default defineStore('app', {
  state: (): AppState => {
    return {
      env: 'browser', // browser | miniprogram | app,
      entry: 'claimCentre', // 入口: satisfy, claimCentre, claimType
      waybillNo: '', // 运单号
      lang: 'en', // 语言
      isMobile: true, // 是否是移动端
      channel: '', // 渠道
      config: getConfig(i18n.global, ''),
      token: '',
    }
  },
  actions: {
    setLang(lang: string) {
      i18n.global.locale = lang as 'en' | 'th' | 'zh'
      console.log(i18n.global.locale)
      this.lang = lang
    },
    setWaybillNo(waybillNo: string) {
      this.waybillNo = waybillNo
    },

    setEnv(env: string) {
      this.env = env
    },

    setEntry(entry: string) {
      this.entry = entry
    },
    setIsMobile(isMobile: boolean) {
      this.isMobile = isMobile
    },
    setChannel(channel: string) {
      if(channel == kexApp) {
        this.channel = KEX
      } else {
        this.channel = channel
      }
    },
    setConfig(config: any) {
      this.config = config
    },
    setToken(token: string) {
      this.token = token
    },
  },
  getters: {},
})

